/**
 * AND a chip-filter JSON blob with a search-filter JSON blob.
 *
 * Either side may be absent. A missing or unparseable side is dropped rather
 * than wiping the side that is still valid — a bad chip string must not
 * erase the text query, and the reverse.
 *
 * Search-only stays the caller's shape (phone sends a top-level OR group).
 * Both sides become `{ operator: "AND", groups: [chips, search] }`, the same
 * shape the desktop table already sends.
 */
export function andFilterGroups(
  baseJson: string | undefined,
  extraJson: string | undefined,
): string | undefined {
  const base = parseGroup(baseJson);
  const extra = parseGroup(extraJson);
  if (!base) return extra ? JSON.stringify(extra) : undefined;
  if (!extra) return JSON.stringify(base);
  return JSON.stringify({ operator: "AND", groups: [base, extra] });
}

function parseGroup(raw: string | undefined): unknown | null {
  if (!raw) return null;
  try {
    const value = JSON.parse(raw);
    if (!value || typeof value !== "object" || Array.isArray(value)) return null;
    return value;
  } catch {
    return null;
  }
}
